import { MatDialog } from '@angular/material/dialog';
import { inject, Injectable } from '@angular/core';
import { FrameContractSelectionDialogComponent } from '../dialog/frame-contract-selection-dialog.component';
import { FrameContractSelection } from '../model/frame-contract-selection';

@Injectable({
    providedIn: 'root',
})
export class FrameContractSelectionDialogService {
    matDialog = inject(MatDialog);

    openFrameContractSelectionDialog(frameContractSelectionData: FrameContractSelection[] | null) {
        const dialog = this.matDialog.open(FrameContractSelectionDialogComponent, {
            data: frameContractSelectionData,
        });

        return dialog.afterClosed();
    }
}
